module.exports = __webpack_public_path__ + "media/images/360/gym-80076fc7894fd60b099df1b93374a789.webp";